import { useEffect } from 'react'
import { useAuth } from '../../context/useAuth'
import { useClientPreferences } from '../../context/useClientPreferences'
import { useSubscription } from '../../context/useSubscription'
import { useWorkspace } from '../../context/useWorkspace'
import { registerDebugStateProvider } from '../../utils/debugAppStateRegistry'
import { isPersonalWorkspace } from '../../utils/workspaceKind'

export const DebugStateProvidersBridge = () => {
  const auth = useAuth()
  const prefs = useClientPreferences()
  const workspace = useWorkspace()
  const subscription = useSubscription()

  useEffect(() => registerDebugStateProvider('auth', () => ({
    uid: auth.currentUser?.uid ?? null,
    email: auth.currentUser?.email ?? null,
    displayName: auth.currentUser?.displayName ?? null,
    isAnonymous: auth.currentUser?.isAnonymous ?? null,
    role: auth.userProfile?.role ?? null,
  })), [auth.currentUser?.uid, auth.currentUser?.email, auth.currentUser?.displayName, auth.currentUser?.isAnonymous, auth.userProfile?.role])

  useEffect(() => registerDebugStateProvider('workspace', () => ({
    activeWorkspaceId: workspace.activeWorkspaceId ?? null,
    workspaceCount: workspace.workspaces?.length ?? 0,
    activeWorkspaceKind: isPersonalWorkspace(workspace.workspaces?.find((w) => w.id === workspace.activeWorkspaceId)) ? 'PERSONAL' : 'TEAM',
  })), [workspace.activeWorkspaceId, workspace.workspaces])

  useEffect(() => registerDebugStateProvider('prefs', () => ({
    enableDebugMode: prefs.preferences.enableDebugMode,
    theme: prefs.preferences.theme ?? null,
  })), [prefs.preferences.enableDebugMode, prefs.preferences.theme])

  useEffect(() => registerDebugStateProvider('subscription', () => ({
    plan: subscription.plan,
    isLoading: subscription.isLoading,
    entitlementCount: subscription.entitlements.length,
  })), [subscription.plan, subscription.isLoading, subscription.entitlements.length])

  return null
}
